import { RouterProvider } from '@tanstack/react-router'
import { getRouter } from '../src/router'
import ReactDOM from 'react-dom/client'
import React from 'react'

const router = getRouter()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
)
